// src/utils/authUtils.ts
import {jwtDecode, JwtPayload} from 'jwt-decode';
import {clearTokens} from "../api/authApi";

/**
 * 커스텀 JWT 페이로드 타입
 */
interface CustomJwtPayload extends JwtPayload {
    coordinatorCode: string;
    memberCode?: string;
    role?: string;
}

/**
 * 토큰에서 사용자 정보 추출
 * @returns {Object|null} { memberId, memberCode, role } 또는 null
 */
export const getAuthInfo = () => {
    const accessToken = localStorage.getItem('accessToken');
    if (!accessToken) {
        return null;
    }

    try {
        const decoded = jwtDecode<CustomJwtPayload>(accessToken);

        return {
            memberId: decoded.sub || '',
            memberCode: decoded.memberCode || '',
            role: decoded.role || 'ROLE_MEMBER',
            coordinatorCode: decoded.coordinatorCode || ''
        };
    } catch (error) {
        console.error('토큰 디코딩 실패:', error);
        clearTokens();
        return null;
    }
};

/**
 * 특정 role을 가지고 있는지 확인
 * @param {string} requiredRole - 확인할 role
 * @returns {boolean}
 */
export const hasRole = (requiredRole: string): boolean => {
    const auth = getAuthInfo();
    return auth !== null && auth.role === requiredRole;
};

/**
 * Coordinator 여부 확인
 * @returns {boolean}
 */
export const isCoordinator = (): boolean => {
    return hasRole('ROLE_COORDINATOR');
};

/**
 * 일반 회원 여부 확인
 * @returns {boolean}
 */
export const isMember = (): boolean => {
    return hasRole('ROLE_MEMBER');
};

/**
 * 로그인 여부 확인
 * @returns {boolean}
 */
export const isLoggedIn = (): boolean => {
    return getAuthInfo() !== null;
};